import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { DateCommon } from './date-common.component';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'date-range-picker',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NzDatePickerModule, ReactiveFormsModule],
  template: `
    <nz-range-picker
      [formControl]="control()"
      [class]="baseClasses"
      [nzPlaceHolder]="placeholder()"
    />
  `,
})
export class DateRangePickerComponent extends DateCommon {}
